let _initProto;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
/* 
  This service responsible for the download functionality 
  It serves the endpoing /download/[fermentationid]
*/

import { Plugin } from "plugin";
import { ReadableStream, TransformStream } from "web-streams";
import * as fs from "fs";
import { URL } from "url";
import Path from "path";
import sleep from "sleep";
import moment from "moment";
import { http } from "appserver";
import { auth } from "appserver";
const PATH = "/home/pi/fermentations";

/* an async generator that reads the input file chunk by chunk and yields each line */
async function* readline(path) {
  const MAXCHUNKSIZE = 5 * 1024;
  var lines = [""];
  var size = fs.statSync(path).size - 1;
  var position = 0;
  var chunk;
  const decoder = new TextDecoder();
  do {
    chunk = decoder.decode(new Uint8Array(fs.readFileSync(path, {
      offset: position,
      count: MAXCHUNKSIZE
    })));
    /*
        chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
          offset: position,
          count: MAXCHUNKSIZE
        })) );
    */
    position += MAXCHUNKSIZE;
    chunk = chunk.split("\n");
    lines[0] += chunk.shift();
    lines = lines.concat(chunk);
    while (lines.length - 1) {
      //await new Promise(resolve => setTimeout(resolve, 0));
      yield lines.shift() + "\n";
    }
    await sleep(0);
  } while (position < size);
  return lines.shift() + "\n";
}
export default class DownloadService extends Plugin {
  static {
    [_initProto] = _applyDecs(this, [], [[[http.get(/^\/api\/pc\/fermentations\/[\w-]+\/download$/), auth.validate()], 2, "fermentation_download"]], 0, void 0, Plugin).e;
  }
  constructor(...args) {
    _initProto(super(...args));
  }
  fermentation_download(request) {
    // ---- use native URL API --------------------------------------------------
    const url = new URL(request.url);
    const parts = url.pathname.split("/");
    const id = parts[parts.length - 2];
    const urlObj = new URL(request.url);
    const pathname = urlObj.pathname;
    const searchParams = urlObj.searchParams; // <-- replace QueryString

    //var pathname = url.parse(request.url).pathname;
    var path;
    path = Path.join("/home/pi/fermentations", id);
    path = Path.normalize(path);
    if (!path.startsWith("/home/pi/fermentations/")) throw new Error("Access denied");
    var fermentation = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path + "/parameters.json"))));
    path += "/values.json";
    if (!fs.existsSync(path)) return new Response(new TextEncoder().encode("not found").buffer, {
      status: 404
    });
    var readableStream = new ReadableStream({
      iterator: null,
      start(controller) {
        this.iterator = readline(path);
      },
      async pull(controller) {
        //await sleep(10);
        var obj = await this.iterator.next();
        if (obj.done) {
          controller.close();
        } else {
          controller.enqueue(obj.value);
        }
      },
      cancel() {}
    }, {
      highWaterMark: 1
    });
    var toJSONTransformStream = new TransformStream({
      transform(chunk, controller) {
        try {
          var obj = JSON.parse(chunk);
          controller.enqueue(obj);
        } catch (e) {
          console.warn("Bad entry at database. Skipped.");
        }
      }
    });
    var addElapsedHourTransformStream = new TransformStream({
      startDate: null,
      start(controller) {
        this.startTime = new Date(fermentation.inoculationDate).getTime();
      },
      transform(chunk, controller) {
        //if (!this.startDate) this.startDate = moment(chunk.dt);
        //chunk.h = moment.duration(moment(chunk.dt).diff(this.startDate)).asHours();
        if (!this.startTime) this.startTime = new Date(chunk.dt).getTime();
        var currTime = new Date(chunk.dt).getTime();
        chunk.h = (currTime - this.startTime) / (1000 * 60 * 60);
        controller.enqueue(chunk);
      }
    });
    var hourlyAverageTransformStream = new TransformStream({
      i: 0,
      h: null,
      avgchunk: null,
      start(controller) {
        this.startDate = fermentation.inoculationDate;
      },
      transform(chunk, controller) {
        var h2 = Math.round(chunk.h);
        if (this.h === null) this.h = h2;
        if (this.avgchunk === null) this.avgchunk = Object.assign({}, chunk); //this.avgchunk = JSON.parse(JSON.stringify(chunk));

        /* if the hour is the same we keep summing up the values */
        if (this.h == h2) {
          for (const [key, value] of Object.entries(chunk)) {
            if (key == "dt") continue;
            if (key == "h") continue;
            this.avgchunk[key] += value;
          }
          this.i++;
        } else {
          /* if the hour changes in the stream we enqueue the average so far */
          for (const [key, value] of Object.entries(this.avgchunk)) {
            if (key == "dt") continue;
            if (key == "h") continue;
            this.avgchunk[key] /= this.i;
          }
          this.avgchunk.h = this.h;
          controller.enqueue(this.avgchunk);
          this.i = 0;
          //this.avgchunk = JSON.parse(JSON.stringify(chunk));  
          this.avgchunk = Object.assign({}, chunk);
          this.h = h2;
        }
      }
    });
    var toCSVTransformStream = new TransformStream({
      headerSend: false,
      transform(chunk, controller) {
        var str = "";

        /* add csv header if */
        if (!this.headerSent) {
          for (const [key, value] of Object.entries(chunk)) {
            str += `${key},`;
          }
          str += "\n";
          this.headerSent = true;
        }
        for (const [key, value] of Object.entries(chunk)) {
          /* dt should be always included, Number isFinite filters '-' dashes (wrong data) */
          if (key == "dt" || Number.isFinite(value)) {
            str += `${value},`;
          } else {
            str += `,`;
          }
        }
        str += "\n";
        controller.enqueue(str);
      }
    });
    var toXMLTransformStream = new TransformStream({
      start(controller) {
        controller.enqueue("<root>\n");
      },
      transform(chunk, controller) {
        controller.enqueue("<todo></todo>\n");
      },
      flush(controller) {
        controller.enqueue("</root>\n");
      }
    });
    var toNDJSONTransformStream = new TransformStream({
      transform(chunk, controller) {
        var str = JSON.stringify(chunk) + "\n";
        controller.enqueue(str);
      }
    });
    var textEncoderTransformStream = new TransformStream({
      transform(chunk, controller) {
        var arrayBufferChunk = new TextEncoder().encode(chunk).buffer;
        //controller.enqueue( new TextEncoder().encode(`${arrayBufferChunk.byteLength.toString(16)}\r\n`).buffer );
        controller.enqueue(arrayBufferChunk);
        //controller.enqueue( (new TextEncoder().encode("\r\n")).buffer );                
      },
      flush(controller) {
        //controller.enqueue( (new TextEncoder().encode("0\r\n\r\n")).buffer );                
      }
    });
    readableStream = readableStream.pipeThrough(toJSONTransformStream);
    if (true) readableStream = readableStream.pipeThrough(addElapsedHourTransformStream);

    //if (searchParams.hourlyAverage) 
    if (searchParams.has("hourlyAverage")) readableStream = readableStream.pipeThrough(hourlyAverageTransformStream);
    switch (searchParams.get("format")) {
      case "csv":
        readableStream = readableStream.pipeThrough(toCSVTransformStream);
        break;
      case "xml":
        readableStream = readableStream.pipeThrough(toXMLTransformStream);
        break;
      case "ndjson":
        readableStream = readableStream.pipeThrough(toNDJSONTransformStream);
        break;
    }
    readableStream = readableStream.pipeThrough(textEncoderTransformStream);
    var response = new Response(readableStream);
    var contentType = {
      csv: "text/csv",
      xml: "application/xml",
      ndjson: "application/json"
    }[searchParams.get("format")];
    response.headers.set("Content-Type", contentType);
    response.headers.set("Transfer-Encoding", "chunked");
    return response;
  }
}